import axios from 'axios';
import { baseUrl } from '../utils/baseUrl';
const BASE_URL = baseUrl();

export const setLogin = user => {
    const basicAuth = 'Basic ' + btoa(`${user.userName}|${user.password}|${user.memoryCharged}|${window.location.origin}`);
    //const basicAuth = 'Basic ' + btoa(`${user.userName}:${user.password}:${user.memoryCharged}`);
    //const basicAuth = 'Basic ' + btoa(`${user.userName}:${user.password}`);
    const credentials = {
        headers:
        {
            'Authorization': basicAuth
        }
    }
    return axios.get(`${BASE_URL}/connexion`, credentials)
        .catch((err) => {
            const status = err && err.response ? err.response.status : undefined;
            const data = err && err.response ? err.response.data : undefined;
            throw { status, data, err }; // propagate error
        });

}

export const sendOtpSignOn = user => {
    const basicAuth = 'Basic ' + btoa(`${user.userName}|${user.password}|${user.memoryCharged}|${window.location.origin}`);
    const credentials = {
        userName: user.userName,
        isCharged: user.memoryCharged,
        urlPartnerie: window.location.origin
    }
    return axios.post(`${BASE_URL}/beneficiaire/sendOTPLoginCode`, credentials, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } })
        .catch((err) => {
            const status = err && err.response ? err.response.status : undefined;
            const data = err && err.response ? err.response.data : undefined;
            throw { status, data, err }; // propagate error
        });
}

export const signOn = data => axios.post(`${BASE_URL}/beneficiaire/create`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const otpVerification = data => axios.post(`${BASE_URL}/beneficiaire/validateOTPLoginCode`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const validationAccount = data => axios.post(`${BASE_URL}/beneficiaire/activate/${data.user}?code=${data.code}`, { code: data.code }, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const getBeneficiary = credentials => axios.get(`${BASE_URL}/beneficiaire/me`, { headers: { 'Authorization': 'Basic ' + credentials } });

export const getAssistanceAgreementData = (idBeneficiaire, idPartenaire) => axios.get(`${BASE_URL}/funeralAssistanceAgreement/${idBeneficiaire}?idPartner=${idPartenaire}`, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const setAssistanceAgreementData = (data, idPartenaire) => axios.post(`${BASE_URL}/funeralAssistanceAgreement/update?idPartner=${idPartenaire}`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const deleteCollectionWills = (BeneficiaryId, idPartenaire) => axios.post(`${BASE_URL}/beneficiaire/deleteCollectionWills?idPartner=${idPartenaire}`, { "id": BeneficiaryId }, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const sendCollectionWills = (BeneficiaryId, idPartenaire) => axios.post(`${BASE_URL}/beneficiaire/sendCollectionWills?idPartner=${idPartenaire}`, { "id": BeneficiaryId }, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const getStateHeadingData = (idBeneficiaire, idPartenaire, credentials) => axios.get(`${BASE_URL}/rubrique/getallRubriquesState/${idBeneficiaire}?idPartner=${idPartenaire}`, { headers: { 'Authorization': 'Basic ' + credentials } });

export const getMemoryChargedData = (idBeneficiaire, idPartenaire) => axios.get(`${BASE_URL}/memoryWorkers/getAll/${idBeneficiaire}?idPartner=${idPartenaire}`, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const createMemoryCharged = (data, idPartenaire) => axios.post(`${BASE_URL}/memoryWorkers/create?idPartner=${idPartenaire}`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const createAssistanceAgreement = data => axios.put(`${BASE_URL}/beneficiaire/updateProfile`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const createLegalInformationData = (data, idPartenaire) => axios.put(`${BASE_URL}/legalinformations?idPartner=${idPartenaire}`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const getLegalInformationData = (data, idPartenaire) => axios.get(`${BASE_URL}/legalinformations/${data}?idPartner=${idPartenaire}`, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const updateAccount = (data, idPartenaire) => axios.put(`${BASE_URL}/beneficiaire/updateAccount?idPartner=${idPartenaire}`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const getMesObsequesData = (idBeneficiaire, idPartenaire) => axios.get(`${BASE_URL}/funeral/${idBeneficiaire}?idPartner=${idPartenaire}`, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const saveMesObsequesData = (data, idPartenaire) => axios.post(`${BASE_URL}/funeral/save?idPartner=${idPartenaire}`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const reset = data => axios.put(`${BASE_URL}/beneficiaire/reset`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const postObituaryData = (data, idPartenaire) => axios.put(`${BASE_URL}/deathNotice?idPartner=${idPartenaire}`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const getObituaryData = (data, idPartenaire) => axios.get(`${BASE_URL}/deathNotice/${data}?idPartner=${idPartenaire}`, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const getCountryData = () => axios.get(`${BASE_URL}/pays`, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const updatePassword = data => axios.post(`${BASE_URL}/beneficiaire/updatePassword`, data);

export const getPartenaire = () => axios.get(`${BASE_URL}/partenaire?url=` + window.location.origin, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const getCgu = () => axios.get(`${BASE_URL}/cgu?url=` + window.location.origin);

export const getCguByPartenaireAndCode = (partenaire, code) => axios.get(`${BASE_URL}/cgu/cgu?&partenaire=${partenaire}&code=${code}`);

export const uploadFile = (data, idPartenaire) => axios.post(`${BASE_URL}/files/upload?idPartner=${idPartenaire}`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const deleteFile = (data, idPartenaire) => axios.post(`${BASE_URL}/files/delete?idPartner=${idPartenaire}`, data, { headers: { 'Authorization': 'Basic ' + sessionStorage.defaultID } });

export const activateMemory = data => axios.post(`${BASE_URL}/beneficiaire/activateMemory/${data.userId}?code=${data.code}&password=${data.password}`, {});

const encodeForm = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
        .join('&');
}


export const download = (data, idPartenaire) => xhrRequest({
    method: 'POST',
    url: `${BASE_URL}/files/download?idPartner=${idPartenaire}`,
    params: data,
    headers: {
        'Authorization': 'Basic ' + sessionStorage.defaultID,
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "application/octet-stream"
    }
});

const xhrRequest = (opts) => {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(opts.method, opts.url, true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve({
                    response: xhr.response,
                    type: xhr.getResponseHeader('Content-Type')
                });
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        if (opts.headers) {
            Object.keys(opts.headers).forEach(function (key) {
                xhr.setRequestHeader(key, opts.headers[key]);
            });
        }
        xhr.send(encodeForm(opts.params));
    });
}




// WEBPACK FOOTER //
// ./src/api/api.js